/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* *MARK*: spin-to-win email collection popup */
  class SpinToWinPopup extends HTMLElement {
    angleToDiscountAmount = [
      '2', '10', '15', '5',
      '20', '10', '15', '5',
    ];

    constructor() {
      super();
      if (!this.readCookie(this.dataset.cookieName)) {
        this.init();
      }
    }

    init() {
      this.querySelector('.popup__close').addEventListener('click', this.hidePopup.bind(this, false));
      this.querySelector('.spin-to-win__spin-button').addEventListener('click', this.spinWheel.bind(this, false));
      setTimeout(() => this.showPopup(), 3000);
    }

    showPopup() {
      this.querySelector('.popup').classList.add('popup--visible');
    }

    hidePopup() {
      this.querySelector('.popup').classList.remove('popup--visible');
      this.writeCookie(this.dataset.cookieName, 'user_has_closed');
    }

    spinWheel() {
      const finalAngle = Math.floor(Math.random() * 360);
      document.documentElement.style.setProperty('--spin-to-win-final-angle', `${finalAngle}deg`);
      this.querySelector('svg.spin-to-win__wheel').classList.add('spin-to-win__wheel-animate');

      const discountAmountIdx = Math.floor(finalAngle / 45);
      const discountAmount = this.angleToDiscountAmount[discountAmountIdx];
      setTimeout(() => {
        // transition from wheel view to email collection form view
        this.querySelector('.spin-to-win__discount-amount').innerHTML = `${discountAmount}%`;
        this.querySelector('.spin-to-win__customer-tags').setAttribute('value', `spin-to-win,discount${discountAmount}`);
        this.querySelector('.spin-to-win__container--wheel').classList.add('visually-hidden');
        this.querySelector('.spin-to-win__container--email').classList.remove('visually-hidden');
      }, 6000);
    }

    // cookie code comes from class PopupCookie in dev.theme.js
    writeCookie(name, value) {
      const hasCookie = document.cookie.indexOf('; ') !== -1 && !document.cookie.split('; ').find((row) => row.startsWith(name));
      if (hasCookie || document.cookie.indexOf('; ') === -1) {
        document.cookie = `${name}=${value}; expires=null; path=/; domain=${window.location.hostname}; sameSite=none; secure=true`;
      }
    }

    readCookie(name) {
      if (document.cookie.indexOf('; ') !== -1 && document.cookie.split('; ').find((row) => row.startsWith(name))) {
        const returnCookie = document.cookie
          .split('; ')
          .find((row) => row.startsWith(name))
          .split('=')[1];

        return returnCookie;
      } else {
        return false;
      }
    }
  }

  window.customElements.define('spin-to-win-popup', SpinToWinPopup);
  /* *ENDMARK*: spin-to-win email collection popup */






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
